import React from "react";

const UseCasesSection = ({ useCases, t }) => (
  <section className="use-cases anim-section home-section" id="casos">
    <div className="home-container">
      <div className="section-head">
        <h2>{t.useCases.head}</h2>
        <p>{t.useCases.sub}</p>
      </div>
      <div className="usecase-grid">
        {useCases.map((useCase) => (
          <article className="usecase-card card-animated anim-card" key={useCase.title}>
            <h3>{useCase.title}</h3>
            <div className="usecase-row">
              <span>{t.useCases.labels.objetivo}</span>
              <strong>{useCase.goal}</strong>
            </div>
            <div className="usecase-row">
              <span>{t.useCases.labels.mide}</span>
              <strong>{useCase.metrics}</strong>
            </div>
            <div className="usecase-row">
              <span>{t.useCases.labels.evidencia}</span>
              <strong>{useCase.evidence}</strong>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default UseCasesSection;
